import { render, staticRenderFns } from "./AboutUsPageData.vue?vue&type=template&id=02b33483&scoped=true&"
import script from "./AboutUsPageData.vue?vue&type=script&lang=js&"
export * from "./AboutUsPageData.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPageData.vue?vue&type=style&index=0&id=02b33483&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b33483",
  null
  
)

export default component.exports